var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-horizontal-holder"},[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-8646725163503313","data-ad-slot":"3638232929","data-ad-format":"auto","data-full-width-responsive":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }